import styled from "styled-components";

export const CloseButton = styled.button`
  position: fixed;
  bottom: 78px; /* Dostosuj w zależności od rozmiaru bańki Crisp */
  right: 15px; /* Dostosuj w zależności od rozmiaru bańki Crisp */
  z-index: 999999;
  background-color: ${({ theme }) => theme.color.spotifyDarkGrey};
  color: white;
  border: none;
  border-radius: 15%;
  width: 24px;
  height: 14px;
  font-size: 14px;
  
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  padding: 0;
  // box-shadow: 0 2px 5px rgba(0,0,0,0.2);

  &:hover {
    background-color: ${({ theme }) => theme.color.spotifyLightGrey};
  }
`;

export const ShowChatButton = styled.button`
  position: fixed;
  bottom: 0px;
  right: 20px;
  z-index: 999999;
  background-color: ${({ theme }) => theme.color.spotifyDarkGreen};
  color: white;
  border: none;
 border-radius: 10px 10px 0 0;
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
  opacity: 0.6;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }

  span {
    font-weight: 500;
  }
`;
